module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1230"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1230"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.15875",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};